<template>
    <div class="progress-bar-container">
        <div
            v-if="lastStatusColor"
            class="bar"
            :style="`background-color: ${lastStatusColor};`"
        />
    </div>
</template>

<script>

export default {
    props: {
        data: {
            type: Array,
            default: [],
            required: true
        }
    },
    computed: {
        lastStatusColor() {
            return this.data[this.data.length - 1]?.color || null;
        }
    }
}
</script>

<style lang="scss" scoped>
.progress-bar-container {
    width: 100%;
    margin: 16px 0;

    display: flex;

    .bar {
        height: 16px;
        width: 100%;
        border-radius: 16px;
    }
}
</style>
